import { useTheme } from '@emotion/react';
import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import LicenseKeyModel from '@shared/models/organizations/LicenseKeyModel';
import { useTranslation } from 'react-i18next';

interface LicenseKeyAvailableSelectProps {
    value: string;
    onUpdate: (field: 'key', value: string) => void;
    handleLicenseKeyChange: (key: LicenseKeyModel) => void;
    results: LicenseKeyModel[];
    loadingData: boolean;
}

export default function LicenseKeyAvailableSelect({
    value,
    onUpdate,
    handleLicenseKeyChange,
    results = [],
    loadingData,
}: LicenseKeyAvailableSelectProps) {
    const { t } = useTranslation();
    const theme = useTheme();
    const handleUpdate = (key: string) => {
        const selectedKey = results.find((k) => k.accessCode === key);
        if (selectedKey) {
            onUpdate('key', key);
            handleLicenseKeyChange(selectedKey);
        }
    };

    return (
        <FormControl fullWidth>
            <InputLabel style={{ backgroundColor: theme.color.background }} id="license-key-label">
                Choose a License Key
            </InputLabel>
            <Select
                labelId="license-key-label"
                value={value ?? ''}
                onChange={(e) => handleUpdate(e.target.value)}
                disabled={loadingData || results.length === 0}
                displayEmpty>
                {loadingData ? (
                    <MenuItem disabled>
                        <CircularProgress size={24} />
                        {t('common:loading')}
                    </MenuItem>
                ) : results.length > 0 ? (
                    results.map((key) => (
                        <MenuItem key={key.id} value={key.accessCode}>
                            {key.name} {' | '}
                            {t('common:organization.member.seats.maxSeatValue', 'Max', {
                                value: key.maxMembers,
                            })}
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled>{t('common:license.key.product.title')}</MenuItem>
                )}
            </Select>
        </FormControl>
    );
}
